<template>
  <div class="take_detail">
    <head-top head-title="具体详情" go-back="true"></head-top>
    <div class="take_title">
      <div class="title border-bottom">{{details.title}}</div>
    </div>
    <!--<p v-html="detail.content" ref="box" class="content"></p>-->
    <p class="content" v-html="details.content"></p>
  </div>
</template>
<style lang="scss" scoped>
  p {
    margin: 8px !important;
  }

  .take_detail {
    line-height: normal;
    background-color: #fff;
    overflow: auto;
    height: 100%;
    .mint-button {
      font-size: 12px;
      height: 25px;
      margin-top: 5px;
    }
    .content {
      padding: 0 2px;
      margin-top: 8px;
      font-size: 14px;
    }
    .take_title {
      margin: 40px 10px 0px 10px;
      .title {
        padding: 10px 0;
        text-align: center;
        font-size: 18px;
        line-height: 20px;
        font-weight: 700;
      }
      .desc {
        padding-top: 10px;
        color: #666;
        font-size: 12px;
        text-align: center;
      }
    }
  }
</style>
<script>
  import headTop from '../header/Header.vue'
  import {getTakeInDetail} from '../../api/satisfaction'

  export default {
    name: 'TakeInDetail',
    data() {
      return {
        details: {}
      }
    },
    created() {
      this._getTakeInDetail()
      // 特殊图片预览（夹杂在word文档中的图片）
      // setTimeout(() => {
      //   if (document.getElementsByClassName(' content')[0]) {
      //     let imgbox = document.getElementsByClassName('content')[0].getElementsByTagName('img')
      //     // console.log(imgbox)
      //     var _this = this
      //     for (let i = 0; i < imgbox.length; i++) {
      //       this.img.push(imgbox[i].src)
      //       // console.log(this.img)
      //       imgbox[i].addEventListener('click', function () {
      //         // console.log(imgbox[i].src)
      //         wx.previewImage({
      //           current: imgbox[i].src, // 当前显示图片的http链接
      //           urls: _this.img // 需要预览的图片http链接列表
      //         })
      //       })
      //     }
      //   }
      // }, 1000)
    },
    methods: {
      _getTakeInDetail() {
        getTakeInDetail(this.$route.params.id).then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.details = res.data
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/TakeInDetail.vue